import React from "react";
import { DECK_GEN, CardFront, CardBack } from "./CardGenerator";

/**
 * Pure render page — used by the Playwright capture script.
 * Each card is rendered at full 825 × 1425 pixels stacked vertically
 * with NORMAL positive positioning so element.screenshot() works correctly.
 *
 * Not linked from anywhere user-facing — visit /cards-raw directly.
 */
const CardsRaw = () => {
  return (
    <div style={{ background: "#ffffff", margin: 0, padding: 0 }} data-testid="cards-raw-page">
      {/* Back first */}
      <div data-testid="raw-back" style={{ width: 825, height: 1425 }}>
        <CardBack />
      </div>

      {DECK_GEN.map((card) => (
        <div
          key={card.n}
          data-testid={`raw-card-${card.n}`}
          style={{ width: 825, height: 1425 }}
        >
          <CardFront card={card} />
        </div>
      ))}
    </div>
  );
};

export default CardsRaw;
